import { atom, useAtom, useSetAtom } from 'jotai';

export const isIOLoading = atom(false);

export const useInsertionOrderLoading = () => {
  const [isLoading, setIsLoading] = useAtom(isIOLoading);

  return { isLoading, setIsLoading };
};

export const useSetInsertionOrderLoading = () => {
  const setIsLoading = useSetAtom(isIOLoading);

  return setIsLoading;
};
